import React from 'react';
import styled from '@emotion/styled';
import { bucketLog, type BucketLogData } from '@bucketplace/bucket-log';
import { LinkComponentType } from '@bucketplace/common';
import { ResizeImage, Text } from '@bucketplace/design-system';

export interface RankingStoreItemProps {
  href?: string;
  linkComponent?: LinkComponentType;
  logData?: BucketLogData;
  productDiscount?: number;
  productImageUrl: string;
  productName: string;
  productPrice: string;
  rank: number;
}

export function RankingStoreItem(props: RankingStoreItemProps) {
  const {
    href,
    linkComponent,
    logData,
    productDiscount,
    productImageUrl,
    productName,
    productPrice,
    rank,
  } = props;

  return (
    <Root
      as={linkComponent}
      href={href}
      onClick={() => {
        if (!logData) {
          return;
        }

        bucketLog({
          category: 'click',
          ...logData,
        });
      }}
    >
      <Rank
        variant="body15L24"
        weight={700}
        color="foreground"
        align="center"
      >
        { rank }
      </Rank>

      <Product>
        <ProductImage
          src={productImageUrl}
          quality={50}
          intrinsicAspect={1}
          alt={`${productName} 상품 썸네일 이미지`}
        />

        <ProductBody>
          <Text
            variant="body14L18"
            color="foreground"
            truncate={{ overflow: 'ellipsis', rows: 2 }}
          >
            { productName }
          </Text>

          <ProductPrice>
            { productDiscount != null && (
              <Text
                variant="body14L18"
                color="foregroundBrand"
                weight="semibold"
              >
                { productDiscount }
                %
              </Text>
            ) }

            <Text
              variant="body14L18"
              color="foreground"
              weight="semibold"
            >
              { productPrice }
              원
            </Text>
          </ProductPrice>
        </ProductBody>
      </Product>
    </Root>
  );
}

const Root = styled.a`
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Rank = styled(Text)`
  width: 20px;
  flex-shrink: 0;
`;

const Product = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
`;

const ProductImage = styled(ResizeImage)`
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
`;

const ProductBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: space-between;
`;

const ProductPrice = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
